// Type Definitions
import { UploadFile } from "antd/es/upload/interface";

export const uploadedFileTypeCheck = async (accept?: string, fileList?: UploadFile<any>[]) => {
	const acceptFileTypeArray = accept?.split(",")?.map(function (item) {
		return item.trim();
	});
	return fileList?.every((item) => {
		const uploadedFileType = item?.type ? `.${item.type?.substring(item.type.lastIndexOf("/") + 1)}` : `.${item.name?.substring(item.name.lastIndexOf(".") + 1)}`;
		return acceptFileTypeArray?.includes(uploadedFileType);
	});
};
